<div class="color-field" [class.color-field--disabled]="isDisabled">
  <div class="color-field__meta">
    <label class="color-field__label" [attr.for]="inputId">{{ label }}</label>
    @if (hint) {
      <p class="color-field__hint">{{ hint }}</p>
    }
  </div>

  <div class="color-field__preview-group">
    <span class="color-field__preview-label">Current</span>
    <div
      class="color-field__preview"
      [class.color-field__preview--default]="isDefault"
      [class.color-field__preview--transparent]="isTransparent"
      [class.color-field__preview--invalid]="hasInvalidValue"
      [style.background]="normalizedPreviewColor && normalizedPreviewColor !== 'transparent' ? normalizedPreviewColor : null"
      [style.color]="previewTextColor">
      <span class="color-field__preview-value">{{ displayValue }}</span>
    </div>
  </div>

  <div class="color-field__controls">
    <div class="color-field__picker">
      <input
        #nativePicker
        type="color"
        class="color-field__native-input"
        aria-hidden="true"
        tabindex="-1"
        [value]="pickerColor"
        [disabled]="isDisabled"
        (input)="applyPickerColor($any($event.target).value)">
      <button
        type="button"
        [id]="inputId"
        class="color-field__picker-trigger"
        [disabled]="isDisabled"
        [attr.aria-label]="'Open color picker for ' + label"
        (click)="openNativePicker(nativePicker, $event)">
        <span>Pick color</span>
      </button>
    </div>

    <div class="color-field__shortcuts">
      <button type="button" class="color-field__shortcut" [disabled]="isDisabled" (click)="setDefaultValue($event)">
        Default
      </button>
      @if (supportsTransparent) {
        <button type="button" class="color-field__shortcut" [disabled]="isDisabled" (click)="setTransparentValue($event)">
          Transparent
        </button>
      }
    </div>
  </div>

  @if (control.touched && hasInvalidValue) {
    <p class="color-field__error">
      Enter a hex color like #112233{{ supportsTransparent ? ', transparent,' : '' }} or leave the field blank.
    </p>
  }
</div>
